<template>
  <div class="chat-box-mobile">
    <div v-show="isOpen">
      <div class="cbp-content" :style="{height: viewHeight+'px'}" v-loading="conversationLoading">
        <div class="cbp-content-head flex align-center space-bt">
          <img class="head-img-hh" v-if="isHedgehood" src="https://main.d1dqfa1gmgshev.amplifyapp.com/imgs/logo/hh-chat-logo.png" alt="">
          <img class="head-img-zero" v-else src="https://main.d1dqfa1gmgshev.amplifyapp.com/imgs/logo/zero-chat-logo.png" alt="">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="cursor mgr-24" @click="toHelpCenter">
              <path d="M20.4375 3H14.8125C14.5031 3 14.25 3.25158 14.25 3.5625C14.25 3.87342 14.5031 4.125 14.8125 4.125H19.0805L13.2902 9.91523C13.0705 10.135 13.0705 10.4911 13.2902 10.7105C13.51 10.9298 13.8661 10.9302 14.0855 10.7105L19.875 4.92059V9.1875C19.875 9.49687 20.1281 9.75 20.4375 9.75C20.7469 9.75 21 9.49687 21 9.1875V3.5625C21 3.25158 20.7469 3 20.4375 3ZM9.91523 13.2902L4.125 19.0805V14.8125C4.125 14.5031 3.87328 14.25 3.5625 14.25C3.25172 14.25 3 14.5031 3 14.8125V20.4375C3 20.7469 3.25158 21 3.5625 21H9.1875C9.49687 21 9.75 20.7469 9.75 20.4375C9.75 20.1281 9.49687 19.875 9.1875 19.875H4.92059L10.7108 14.0848C10.9305 13.865 10.9305 13.5089 10.7108 13.2895C10.4911 13.0702 10.1332 13.0688 9.91523 13.2902Z" fill="#222C30"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="cursor" @click="isOpen=false">
              <path d="M21.3111 7.25195L21.01 6.94688C20.8107 6.74492 20.4883 6.74492 20.289 6.94688L12.002 15.3473L3.71066 6.94688C3.51133 6.74492 3.18901 6.74492 2.98968 6.94688L2.68856 7.25195C2.48923 7.45391 2.48923 7.78047 2.68856 7.98242L11.6372 17.0531C11.8366 17.2551 12.1589 17.2551 12.3582 17.0531L21.3069 7.98242C21.5104 7.78047 21.5104 7.45391 21.3111 7.25195Z" fill="#222C30"/>
            </svg>
          </div>
        </div>
        <div class="_lineBgColor" :style="{height: 'calc(100%  - 64px - '+chatBoxHeight*1+'px)'}" v-if="demoContent.length>0">
          <ul class="_lineBgColor cbp-content-chat" :style="{maxHeight: '100%'}" @scroll="handleScroll">
            <li v-if="showYesOrNo" class="common-check-container">
              <span class="cursor common-check font-16 bold mgr-16" :class="currentActive=='Now'?'_activeWhiteBgColor':'_whiteBgColor'" @click="changeActive('Now')">{{ translate("Now") }}</span>
              <span class="cursor common-check font-16 bold _whiteBgColor" :class="currentActive=='Maybe later'?'_activeWhiteBgColor':'_whiteBgColor'" @click="changeActive('Maybe later')">{{ translate("Maybe later") }}</span>
            </li>
            <li v-for="(item, index) in demoContent" :key="item.id">
              <div class="flex space-center _font-14 _timeColor medium" v-show="initTimeStamp(item.created, index)!=''">{{ initTimeStamp(item.created, index) }}</div>
              <div class="common-li self-li" v-if="item.self">
                <div class="flex relative">
                  <div class="common-li-tool">
                    <div class="retry" v-if="item.isError" @click="sendMessage(true, item)">
                      <svg class="error-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 17V15H13V17H11ZM11 7V13H13V7H11Z" fill="#BC2B35"/>
                      </svg>
                    </div>
                    <div class="msg-loading-wrap" v-if="item.sendingMsg">
                      <font-awesome-icon
                        class="loading-icon"
                        icon="fal fa-spinner-third"
                      />
                    </div>
                  </div>
                  <div class="replay-content _chatGreenBgColor" @click="expandImg" :class="item.content.indexOf('%noPaddingParent%')!==-1&&item.quote==null?'no-padding-bd':''">
                    <div class="flex flex-end">
                      <div class="mgr-16">
                        <!-- 类容 -->
                        <div>
                          <div class="word-break font-14 space-pre-line medium line-30" v-if="item.content&&item.contentIsHtml" v-html="escapeHTML(item.content)"></div>
                          <div class="word-break font-14 space-pre-line medium line-30" v-if="item.content&&!item.contentIsHtml">{{ item.content }}</div>
                        </div>
                        <!-- 附件 -->
                        <div class="attach" v-if="item.attachments && item.attachments.length > 0">
                          <div class="file-list" v-if="item.content==''&&item.attachments.length==1">
                            <a class="self-c-a _medium flex align-center" href="javascript:;" @click="download(item.attachments[0])">
                              <span class="_medium mgr-4 _underline _1E333BFontColor attachment_wrap line-30">{{ item.attachments[0].filename }}</span>
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M13.3538 5.14625L9.85375 1.64625C9.80728 1.59983 9.75212 1.56303 9.69143 1.53793C9.63073 1.51284 9.56568 1.49995 9.5 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5H12.5C12.7652 14.5 13.0196 14.3946 13.2071 14.2071C13.3946 14.0196 13.5 13.7652 13.5 13.5V5.5C13.5001 5.43432 13.4872 5.36927 13.4621 5.30858C13.437 5.24788 13.4002 5.19272 13.3538 5.14625ZM10 3.20688L11.7931 5H10V3.20688ZM12.5 13.5H3.5V2.5H9V5.5C9 5.63261 9.05268 5.75979 9.14645 5.85355C9.24021 5.94732 9.36739 6 9.5 6H12.5V13.5ZM9.85375 8.64625C9.90021 8.6927 9.93706 8.74786 9.9622 8.80855C9.98734 8.86925 10.0003 8.9343 10.0003 9C10.0003 9.0657 9.98734 9.13075 9.9622 9.19145C9.93706 9.25214 9.90021 9.3073 9.85375 9.35375C9.8073 9.40021 9.75214 9.43706 9.69145 9.4622C9.63075 9.48734 9.5657 9.50028 9.5 9.50028C9.4343 9.50028 9.36925 9.48734 9.30855 9.4622C9.24786 9.43706 9.1927 9.40021 9.14625 9.35375L8.5 8.70687V11.5C8.5 11.6326 8.44732 11.7598 8.35355 11.8536C8.25979 11.9473 8.13261 12 8 12C7.86739 12 7.74021 11.9473 7.64645 11.8536C7.55268 11.7598 7.5 11.6326 7.5 11.5V8.70687L6.85375 9.35375C6.8073 9.40021 6.75214 9.43706 6.69145 9.4622C6.63075 9.48734 6.5657 9.50028 6.5 9.50028C6.4343 9.50028 6.36925 9.48734 6.30855 9.4622C6.24786 9.43706 6.1927 9.40021 6.14625 9.35375C6.09979 9.3073 6.06294 9.25214 6.0378 9.19145C6.01266 9.13075 5.99972 9.0657 5.99972 9C5.99972 8.9343 6.01266 8.86925 6.0378 8.80855C6.06294 8.74786 6.09979 8.6927 6.14625 8.64625L7.64625 7.14625C7.69269 7.09976 7.74783 7.06288 7.80853 7.03772C7.86923 7.01256 7.93429 6.99961 8 6.99961C8.06571 6.99961 8.13077 7.01256 8.19147 7.03772C8.25217 7.06288 8.30731 7.09976 8.35375 7.14625L9.85375 8.64625Z" class="_034F21Fill"/>
                              </svg>
                            </a>
                            <div class="_font-12 w-100" v-if="!['jpeg','png','gif','webp','bmp','apng','ico','avif','svg'].includes(item.attachments[0].filename.split('.')[1])">{{ (item.attachments[0].fileSize/1024/1024).toFixed(2) }}MB</div>
                          </div>
                          <div class="file-list" v-else>
                            <a class="self-c-a _medium flex align-center" href="javascript:;" @click="download(file)" v-for="(file, ind) in item.attachments" :key="ind">
                              <span class="_medium mgr-4 _underline _1E333BFontColor attachment_wrap line-30">{{ file.filename }}</span>
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M13.3538 5.14625L9.85375 1.64625C9.80728 1.59983 9.75212 1.56303 9.69143 1.53793C9.63073 1.51284 9.56568 1.49995 9.5 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5H12.5C12.7652 14.5 13.0196 14.3946 13.2071 14.2071C13.3946 14.0196 13.5 13.7652 13.5 13.5V5.5C13.5001 5.43432 13.4872 5.36927 13.4621 5.30858C13.437 5.24788 13.4002 5.19272 13.3538 5.14625ZM10 3.20688L11.7931 5H10V3.20688ZM12.5 13.5H3.5V2.5H9V5.5C9 5.63261 9.05268 5.75979 9.14645 5.85355C9.24021 5.94732 9.36739 6 9.5 6H12.5V13.5ZM9.85375 8.64625C9.90021 8.6927 9.93706 8.74786 9.9622 8.80855C9.98734 8.86925 10.0003 8.9343 10.0003 9C10.0003 9.0657 9.98734 9.13075 9.9622 9.19145C9.93706 9.25214 9.90021 9.3073 9.85375 9.35375C9.8073 9.40021 9.75214 9.43706 9.69145 9.4622C9.63075 9.48734 9.5657 9.50028 9.5 9.50028C9.4343 9.50028 9.36925 9.48734 9.30855 9.4622C9.24786 9.43706 9.1927 9.40021 9.14625 9.35375L8.5 8.70687V11.5C8.5 11.6326 8.44732 11.7598 8.35355 11.8536C8.25979 11.9473 8.13261 12 8 12C7.86739 12 7.74021 11.9473 7.64645 11.8536C7.55268 11.7598 7.5 11.6326 7.5 11.5V8.70687L6.85375 9.35375C6.8073 9.40021 6.75214 9.43706 6.69145 9.4622C6.63075 9.48734 6.5657 9.50028 6.5 9.50028C6.4343 9.50028 6.36925 9.48734 6.30855 9.4622C6.24786 9.43706 6.1927 9.40021 6.14625 9.35375C6.09979 9.3073 6.06294 9.25214 6.0378 9.19145C6.01266 9.13075 5.99972 9.0657 5.99972 9C5.99972 8.9343 6.01266 8.86925 6.0378 8.80855C6.06294 8.74786 6.09979 8.6927 6.14625 8.64625L7.64625 7.14625C7.69269 7.09976 7.74783 7.06288 7.80853 7.03772C7.86923 7.01256 7.93429 6.99961 8 6.99961C8.06571 6.99961 8.13077 7.01256 8.19147 7.03772C8.25217 7.06288 8.30731 7.09976 8.35375 7.14625L9.85375 8.64625Z" class="_034F21Fill"/>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="font-12 text-right">{{ timeFormat(item.created, true, false, true) }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="common-li other-li">
                <div class="replay-role" v-if="(item.sender.name==='Support'&&(item.sender.id==1||item.sender.id==2))">
                  <div class="role-icon _chatGreenBgColor">
                    <div style="width:24px;height:24px;display:flex;align-items:center;justify-content:center;border-radius:50%">
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                        <path d="M13.7502 11.0417C12.8426 11.0417 12.4062 11.5626 10.9168 11.5626C9.42743 11.5626 8.99421 11.0417 8.0835 11.0417C5.73714 11.0417 3.8335 13.0014 3.8335 15.4167V16.7709C3.8335 17.6335 4.51337 18.3334 5.35135 18.3334H16.4823C17.3203 18.3334 18.0002 17.6335 18.0002 16.7709V15.4167C18.0002 13.0014 16.0965 11.0417 13.7502 11.0417ZM16.9883 16.7709C16.9883 17.0574 16.7606 17.2917 16.4823 17.2917H5.35135C5.07308 17.2917 4.8454 17.0574 4.8454 16.7709V15.4167C4.8454 13.5776 6.29685 12.0834 8.0835 12.0834C8.70329 12.0834 9.31992 12.6042 10.9168 12.6042C12.5106 12.6042 13.1304 12.0834 13.7502 12.0834C15.5368 12.0834 16.9883 13.5776 16.9883 15.4167V16.7709ZM10.9168 10.0001C13.1525 10.0001 14.9644 8.13485 14.9644 5.83342C14.9644 3.53198 13.1525 1.66675 10.9168 1.66675C8.68115 1.66675 6.86921 3.53198 6.86921 5.83342C6.86921 8.13485 8.68115 10.0001 10.9168 10.0001ZM10.9168 2.70841C12.5896 2.70841 13.9525 4.11141 13.9525 5.83342C13.9525 7.55542 12.5896 8.95842 10.9168 8.95842C9.24402 8.95842 7.88112 7.55542 7.88112 5.83342C7.88112 4.11141 9.24402 2.70841 10.9168 2.70841Z" class="_supportFill"/>
                      </svg>
                    </div>
                  </div>
                  <div class="name font-12">{{ item.sender.name }}</div>
                </div>
                <div class="replay-role" v-else>
                  <img
                    class="role-icon"
                    :src="showNameImg(item.sender.name)"
                    v-if="item.sender.avatar === null"
                  />
                  <img
                    class="role-icon"
                    :src="item.sender.avatar"
                    v-if="item.sender.avatar"
                  />
                  <div class="name font-12">{{ item.sender.name }}</div>
                </div>
                <div class="flex">
                  <div class="replay-content refresh" @click="expandImg" :class="item.content.indexOf('%noPaddingParent%')!==-1&&item.quote==null?'no-padding-bd':''">
                    <div class="flex flex-end">
                      <div class="mgr-16">
                        <div>
                          <div class="word-break font-14 space-pre-line medium line-30" v-if="item.content&&item.contentIsHtml" v-html="escapeHTML(item.content)"></div>
                          <div class="word-break font-14 space-pre-line medium line-30" v-if="item.content&&!item.contentIsHtml">{{ item.content }}</div>
                        </div>
                        <!-- 附件 -->
                        <div class="attach" v-if="item.attachments && item.attachments.length > 0">
                          <div class="file-list" v-if="item.content==''&&item.attachments.length==1">
                            <a class="self-c-a _medium flex align-center" href="javascript:;" @click="download(item.attachments[0])">
                              <span class="_medium mgr-4 _underline _1E333BFontColor attachment_wrap line-30">{{ item.attachments[0].filename }}</span>
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M13.3538 5.14625L9.85375 1.64625C9.80728 1.59983 9.75212 1.56303 9.69143 1.53793C9.63073 1.51284 9.56568 1.49995 9.5 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5H12.5C12.7652 14.5 13.0196 14.3946 13.2071 14.2071C13.3946 14.0196 13.5 13.7652 13.5 13.5V5.5C13.5001 5.43432 13.4872 5.36927 13.4621 5.30858C13.437 5.24788 13.4002 5.19272 13.3538 5.14625ZM10 3.20688L11.7931 5H10V3.20688ZM12.5 13.5H3.5V2.5H9V5.5C9 5.63261 9.05268 5.75979 9.14645 5.85355C9.24021 5.94732 9.36739 6 9.5 6H12.5V13.5ZM9.85375 8.64625C9.90021 8.6927 9.93706 8.74786 9.9622 8.80855C9.98734 8.86925 10.0003 8.9343 10.0003 9C10.0003 9.0657 9.98734 9.13075 9.9622 9.19145C9.93706 9.25214 9.90021 9.3073 9.85375 9.35375C9.8073 9.40021 9.75214 9.43706 9.69145 9.4622C9.63075 9.48734 9.5657 9.50028 9.5 9.50028C9.4343 9.50028 9.36925 9.48734 9.30855 9.4622C9.24786 9.43706 9.1927 9.40021 9.14625 9.35375L8.5 8.70687V11.5C8.5 11.6326 8.44732 11.7598 8.35355 11.8536C8.25979 11.9473 8.13261 12 8 12C7.86739 12 7.74021 11.9473 7.64645 11.8536C7.55268 11.7598 7.5 11.6326 7.5 11.5V8.70687L6.85375 9.35375C6.8073 9.40021 6.75214 9.43706 6.69145 9.4622C6.63075 9.48734 6.5657 9.50028 6.5 9.50028C6.4343 9.50028 6.36925 9.48734 6.30855 9.4622C6.24786 9.43706 6.1927 9.40021 6.14625 9.35375C6.09979 9.3073 6.06294 9.25214 6.0378 9.19145C6.01266 9.13075 5.99972 9.0657 5.99972 9C5.99972 8.9343 6.01266 8.86925 6.0378 8.80855C6.06294 8.74786 6.09979 8.6927 6.14625 8.64625L7.64625 7.14625C7.69269 7.09976 7.74783 7.06288 7.80853 7.03772C7.86923 7.01256 7.93429 6.99961 8 6.99961C8.06571 6.99961 8.13077 7.01256 8.19147 7.03772C8.25217 7.06288 8.30731 7.09976 8.35375 7.14625L9.85375 8.64625Z" class="_034F21Fill"/>
                              </svg>
                            </a>
                            <div class="_font-12 w-100" v-if="!['jpeg','png','gif','webp','bmp','apng','ico','avif','svg'].includes(item.attachments[0].filename.split('.')[1])">{{ (item.attachments[0].fileSize/1024/1024).toFixed(2) }}MB</div>
                          </div>
                          <div class="file-list" v-else>
                            <a class="self-c-a _medium flex align-center" href="javascript:;" @click="download(file)" v-for="(file, ind) in item.attachments" :key="ind">
                              <span class="_medium mgr-4 _underline _1E333BFontColor attachment_wrap line-30">{{ file.filename }}</span>
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M13.3538 5.14625L9.85375 1.64625C9.80728 1.59983 9.75212 1.56303 9.69143 1.53793C9.63073 1.51284 9.56568 1.49995 9.5 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5H12.5C12.7652 14.5 13.0196 14.3946 13.2071 14.2071C13.3946 14.0196 13.5 13.7652 13.5 13.5V5.5C13.5001 5.43432 13.4872 5.36927 13.4621 5.30858C13.437 5.24788 13.4002 5.19272 13.3538 5.14625ZM10 3.20688L11.7931 5H10V3.20688ZM12.5 13.5H3.5V2.5H9V5.5C9 5.63261 9.05268 5.75979 9.14645 5.85355C9.24021 5.94732 9.36739 6 9.5 6H12.5V13.5ZM9.85375 8.64625C9.90021 8.6927 9.93706 8.74786 9.9622 8.80855C9.98734 8.86925 10.0003 8.9343 10.0003 9C10.0003 9.0657 9.98734 9.13075 9.9622 9.19145C9.93706 9.25214 9.90021 9.3073 9.85375 9.35375C9.8073 9.40021 9.75214 9.43706 9.69145 9.4622C9.63075 9.48734 9.5657 9.50028 9.5 9.50028C9.4343 9.50028 9.36925 9.48734 9.30855 9.4622C9.24786 9.43706 9.1927 9.40021 9.14625 9.35375L8.5 8.70687V11.5C8.5 11.6326 8.44732 11.7598 8.35355 11.8536C8.25979 11.9473 8.13261 12 8 12C7.86739 12 7.74021 11.9473 7.64645 11.8536C7.55268 11.7598 7.5 11.6326 7.5 11.5V8.70687L6.85375 9.35375C6.8073 9.40021 6.75214 9.43706 6.69145 9.4622C6.63075 9.48734 6.5657 9.50028 6.5 9.50028C6.4343 9.50028 6.36925 9.48734 6.30855 9.4622C6.24786 9.43706 6.1927 9.40021 6.14625 9.35375C6.09979 9.3073 6.06294 9.25214 6.0378 9.19145C6.01266 9.13075 5.99972 9.0657 5.99972 9C5.99972 8.9343 6.01266 8.86925 6.0378 8.80855C6.06294 8.74786 6.09979 8.6927 6.14625 8.64625L7.64625 7.14625C7.69269 7.09976 7.74783 7.06288 7.80853 7.03772C7.86923 7.01256 7.93429 6.99961 8 6.99961C8.06571 6.99961 8.13077 7.01256 8.19147 7.03772C8.25217 7.06288 8.30731 7.09976 8.35375 7.14625L9.85375 8.64625Z" class="_034F21Fill"/>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="extra">{{ timeFormat(item.created, true, false, true) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="no-chat-container _lineBgColor" :style="{height: 'calc(100%  - 64px - '+chatBoxHeight*1+'px)'}" v-else>
          <img src="https://main.d1dqfa1gmgshev.amplifyapp.com/imgs/logo/no-chat-hh.png" v-if="isHedgehood" class="no-chat-img" alt="">
          <img src="https://main.d1dqfa1gmgshev.amplifyapp.com/imgs/logo/no-chat-zero.png" v-else class="no-chat-img" alt="">
          <div class="font-16 medium mgt-4 _emptyTitleColor" v-if="isHedgehood">{{ translate("Welcome to Hedgehood.") }}</div>
          <div class="font-16 medium mgt-4 _emptyTitleColor" v-else>{{ translate("Welcome to Zero Markets.") }}</div>
          <div class="font-14 mt-1 _emptyDescColor">{{ translate("We’re online 24/5!") }}</div>
        </div>
        <div class="cbp-content-opt _lineBgColor">
          <div id="chat-box-editor"></div>
          <div class="cbp-content-btn flex align-center">
            <el-upload
              class="h-24"
              v-if="!sendLoading"
              accept=".pdf,.png,.jpg,.svg,.jpeg,.bmp,.xlsx,.xls,.doc,.docx"
              :file-list="fileList"
              :http-request="handleRequestComp"
              :action="uploadUrl"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
            >
              <div>
                <el-tooltip class="item" effect="dark" :content="translate('The file can’t be larger than 50 MB.')" placement="top-end" popper-class="self-tooltip">
                  <span class="_extraHover">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M17 11.7656V12.2344C17 12.4922 16.7891 12.7031 16.5312 12.7031H12.7031V16.5312C12.7031 16.7891 12.4922 17 12.2344 17H11.7656C11.5078 17 11.2969 16.7891 11.2969 16.5312V12.7031H7.46875C7.21094 12.7031 7 12.4922 7 12.2344V11.7656C7 11.5078 7.21094 11.2969 7.46875 11.2969H11.2969V7.46875C11.2969 7.21094 11.5078 7 11.7656 7H12.2344C12.4922 7 12.7031 7.21094 12.7031 7.46875V11.2969H16.5312C16.7891 11.2969 17 11.5078 17 11.7656ZM21.6875 12C21.6875 17.3516 17.3516 21.6875 12 21.6875C6.64844 21.6875 2.3125 17.3516 2.3125 12C2.3125 6.64844 6.64844 2.3125 12 2.3125C17.3516 2.3125 21.6875 6.64844 21.6875 12ZM20.4375 12C20.4375 7.31641 16.6367 3.5625 12 3.5625C7.31641 3.5625 3.5625 7.36328 3.5625 12C3.5625 16.6836 7.36328 20.4375 12 20.4375C16.6836 20.4375 20.4375 16.6367 20.4375 12Z"/>
                    </svg>
                  </span>
                </el-tooltip>
              </div>
            </el-upload>
            <div class="h-24 cursor" v-if="sendLoading">
              <el-tooltip class="item" effect="dark" :content="translate('The file can’t be larger than 50 MB.')" placement="top-end" popper-class="self-tooltip">
                <span class="_extraHover">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M17 11.7656V12.2344C17 12.4922 16.7891 12.7031 16.5312 12.7031H12.7031V16.5312C12.7031 16.7891 12.4922 17 12.2344 17H11.7656C11.5078 17 11.2969 16.7891 11.2969 16.5312V12.7031H7.46875C7.21094 12.7031 7 12.4922 7 12.2344V11.7656C7 11.5078 7.21094 11.2969 7.46875 11.2969H11.2969V7.46875C11.2969 7.21094 11.5078 7 11.7656 7H12.2344C12.4922 7 12.7031 7.21094 12.7031 7.46875V11.2969H16.5312C16.7891 11.2969 17 11.5078 17 11.7656ZM21.6875 12C21.6875 17.3516 17.3516 21.6875 12 21.6875C6.64844 21.6875 2.3125 17.3516 2.3125 12C2.3125 6.64844 6.64844 2.3125 12 2.3125C17.3516 2.3125 21.6875 6.64844 21.6875 12ZM20.4375 12C20.4375 7.31641 16.6367 3.5625 12 3.5625C7.31641 3.5625 3.5625 7.36328 3.5625 12C3.5625 16.6836 7.36328 20.4375 12 20.4375C16.6836 20.4375 20.4375 16.6367 20.4375 12Z"/>
                  </svg>
                </span>
              </el-tooltip>
            </div>
            <el-button type="text" :loading="sendLoading" class="special-btn mgl-12" @click="sendMessage(false)">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="cursor" v-show="!sendLoading">
                <path d="M20.5943 2.12419L2.48887 12.5695C1.78183 12.9757 1.87168 13.9601 2.5748 14.257L6.72715 15.9992L17.9498 6.10856C18.1646 5.91715 18.4693 6.21012 18.2857 6.43278L8.87558 17.8976V21.0422C8.87558 21.964 9.98887 22.3273 10.5357 21.6593L13.0162 18.6398L17.8834 20.6789C18.4381 20.9132 19.0709 20.5656 19.1725 19.9679L21.985 3.09294C22.1178 2.30387 21.2701 1.73356 20.5943 2.12419Z" :class="content==''?'_CCCCCCFill':'_0A853BFill'"/>
              </svg>
            </el-button>
            
          </div>
        </div>
      </div>
    </div>
    <div class="expand-img-container" v-show="showImgDialog" @click="showImgDialog=false">
      <div class="eic-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 2.3125C6.64844 2.3125 2.3125 6.64844 2.3125 12C2.3125 17.3516 6.64844 21.6875 12 21.6875C17.3516 21.6875 21.6875 17.3516 21.6875 12C21.6875 6.64844 17.3516 2.3125 12 2.3125ZM12 20.4375C7.36328 20.4375 3.5625 16.6836 3.5625 12C3.5625 7.36328 7.31641 3.5625 12 3.5625C16.6367 3.5625 20.4375 7.31641 20.4375 12C20.4375 16.6367 16.6836 20.4375 12 20.4375ZM15.7031 9.29297L12.9961 12L15.7031 14.707C15.8867 14.8906 15.8867 15.1875 15.7031 15.3711L15.3711 15.7031C15.1875 15.8867 14.8906 15.8867 14.707 15.7031L12 12.9961L9.29297 15.7031C9.10938 15.8867 8.8125 15.8867 8.62891 15.7031L8.29688 15.3711C8.11328 15.1875 8.11328 14.8906 8.29688 14.707L11.0039 12L8.29688 9.29297C8.11328 9.10938 8.11328 8.8125 8.29688 8.62891L8.62891 8.29688C8.8125 8.11328 9.10938 8.11328 9.29297 8.29688L12 11.0039L14.707 8.29688C14.8906 8.11328 15.1875 8.11328 15.3711 8.29688L15.7031 8.62891C15.8828 8.8125 15.8828 9.10938 15.7031 9.29297Z" fill="#FFFFFF"/>
        </svg>
      </div>
      <img class="eic-img" :src="expandImgUrl" alt="">
    </div>
    <div class="cbp-icon" @click="openChatBox">
      <svg
        v-show="isOpen"
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M16.6532 14.9745L25.9795 5.6732C26.1638 5.45856 26.2601 5.18246 26.2492 4.90008C26.2382 4.61771 26.1209 4.34984 25.9205 4.15002C25.7201 3.9502 25.4516 3.83314 25.1684 3.82223C24.8853 3.81133 24.6085 3.90738 24.3932 4.09119L15.067 13.3925L5.74074 4.07997C5.52889 3.86869 5.24158 3.75 4.94199 3.75C4.6424 3.75 4.35508 3.86869 4.14324 4.07997C3.93139 4.29124 3.81238 4.57779 3.81238 4.87658C3.81238 5.17537 3.93139 5.46192 4.14324 5.6732L13.4807 14.9745L4.14324 24.2758C4.02547 24.3764 3.92982 24.5002 3.8623 24.6394C3.79477 24.7786 3.75682 24.9302 3.75084 25.0847C3.74485 25.2392 3.77096 25.3933 3.82752 25.5373C3.88408 25.6813 3.96987 25.812 4.0795 25.9214C4.18914 26.0307 4.32026 26.1163 4.46462 26.1727C4.60899 26.2291 4.76349 26.2551 4.91842 26.2492C5.07336 26.2432 5.22538 26.2054 5.36495 26.138C5.50453 26.0707 5.62863 25.9753 5.72949 25.8578L15.067 16.5565L24.3932 25.8578C24.6085 26.0416 24.8853 26.1377 25.1684 26.1268C25.4516 26.1159 25.7201 25.9988 25.9205 25.799C26.1209 25.5992 26.2382 25.3313 26.2492 25.0489C26.2601 24.7665 26.1638 24.4904 25.9795 24.2758L16.6532 14.9745Z"
          fill="#B2B2B2"
          stroke="#B2B2B2"
          stroke-width="1.2"
        />
      </svg>
      <img v-show="!isOpen&&sendAvatar" :src="sendAvatar" class="icon-img" alt />
      <div class="flex" v-show="!isOpen&&!sendAvatar">
        <svg
          v-if="!isHedgehood"
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="27"
          viewBox="0 0 40 27"
          fill="none"
          style="transform: scale(0.7);"
        >
          <path
            d="M6.66663 0V27H33.3333V0H6.66663ZM27.998 21.598H12.0019V19.7984L18.667 10.8007H12.0019V5.40033H27.998V7.20321L21.333 16.1993H27.998V21.598Z"
            fill="#222C30"
          />
          <path d="M21.333 16.1993H27.998L40 0H33.3334L21.333 16.1993Z" fill="#0BA347" />
          <path d="M18.667 10.8007H12.002L0 27H6.66667L18.667 10.8007Z" fill="#0BA347" />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="27"
          viewBox="0 0 18 20"
          fill="none"
          style="transform: scale(0.7);"
        >
          <mask
            id="mask0_760_3317"
            style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="4"
            y="0"
            width="5"
            height="14"
          >
            <path d="M4.91803 0V13.8108L8.99903 10V0H4.91803Z" fill="white" />
          </mask>
          <g mask="url(#mask0_760_3317)">
            <path
              d="M8.04563 -1.74824L-0.856567 3.22998L5.87403 15.5607L14.7762 10.5825L8.04563 -1.74824Z"
              fill="url(#paint0_linear_760_3317)"
            />
          </g>
          <mask
            id="mask1_760_3317"
            style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="13"
            width="5"
            height="7"
          >
            <path d="M0.837036 17.6236V19.9999H4.91803V13.8127L0.837036 17.6236Z" fill="white" />
          </mask>
          <g mask="url(#mask1_760_3317)">
            <path
              d="M3.98733 12.0792L-1.7283 15.2217L1.7659 21.7329L7.48153 18.5904L3.98733 12.0792Z"
              fill="url(#paint1_linear_760_3317)"
            />
          </g>
          <mask
            id="mask2_760_3317"
            style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="8"
            y="6"
            width="6"
            height="14"
          >
            <path d="M8.99902 10V20H9.00096H13.082V6.18921L8.99902 10Z" fill="white" />
          </mask>
          <g mask="url(#mask2_760_3317)">
            <path
              d="M11.6654 4.22329L2.50513 10.9819L10.4158 21.9664L19.5761 15.2077L11.6654 4.22329Z"
              fill="url(#paint2_linear_760_3317)"
            />
          </g>
          <mask
            id="mask3_760_3317"
            style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="13"
            y="0"
            width="5"
            height="7"
          >
            <path d="M13.082 0V6.18721L17.163 2.37637V0H13.082Z" fill="white" />
          </mask>
          <g mask="url(#mask3_760_3317)">
            <path
              d="M15.996 -1.86959L10.3194 1.76978L14.2521 8.05435L19.9288 4.41498L15.996 -1.86959Z"
              fill="url(#paint3_linear_760_3317)"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_760_3317"
              x1="10.4709"
              y1="13.3712"
              x2="2.50304"
              y2="-0.877201"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#8F00FF" />
              <stop offset="0.14" stop-color="#8F00FF" />
              <stop offset="0.45" stop-color="#830AD1" />
              <stop offset="0.54" stop-color="#7C09C6" />
              <stop offset="0.68" stop-color="#6909A9" />
              <stop offset="0.86" stop-color="#4B077B" />
              <stop offset="1" stop-color="#330756" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_760_3317"
              x1="5.28472"
              y1="21.4"
              x2="1.53543"
              y2="14.5805"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#8F00FF" />
              <stop offset="0.14" stop-color="#8F00FF" />
              <stop offset="0.45" stop-color="#830AD1" />
              <stop offset="0.55" stop-color="#7809C1" />
              <stop offset="0.74" stop-color="#5D0897" />
              <stop offset="1" stop-color="#330756" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_760_3317"
              x1="17.4236"
              y1="21.9112"
              x2="7.14598"
              y2="7.98153"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#8F00FF" />
              <stop offset="0.14" stop-color="#8F00FF" />
              <stop offset="0.41" stop-color="#830AD1" />
              <stop offset="0.5" stop-color="#7D09C9" />
              <stop offset="0.63" stop-color="#6F09B3" />
              <stop offset="0.78" stop-color="#590890" />
              <stop offset="0.97" stop-color="#390760" />
              <stop offset="1" stop-color="#330756" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_760_3317"
              x1="18.2517"
              y1="8.11781"
              x2="11.8057"
              y2="-1.93666"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#8F00FF" />
              <stop offset="0.14" stop-color="#8F00FF" />
              <stop offset="0.45" stop-color="#830AD1" />
              <stop offset="0.92" stop-color="#330756" />
              <stop offset="1" stop-color="#330756" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="unread-count _chatGreenBgColor" v-show="unreadCount>0&&!isOpen">{{ unreadCount > 99 ? '99+' : unreadCount }}</div>
    </div>
  </div>
</template>
<script>
import {
  uploads,
  sendMessage,
  downloadFile,
  checkTicket,
  hisByPage,
  markAsSent
} from "./api";
import E from 'wangeditor';
import moment from "moment";
import axios from "axios";
import DOMPurify from 'dompurify';
export default {
  props: {
    sendAvatar: {
      type: String,
      default: ''
    },
    isHedgehood: {
      type: Boolean,
      default: false
    },
    uploadUrl: {
      type: String,
      default: "https://jsonplaceholder.typicode.com/posts/",
    },
    token: {
      type: String,
      default: "",
    },
    profileUrl: {
      type: String,
      default: "",
    },
    baseUrl: {
      type: String,
      default: "",
    },
    translateLists: {
      type: Array,
    },
    unreadCount: {
      type: Number,
      default: 0
    },
    ticketAdd: {
      type: Number,
      default: 0,
    },
    ticketId: {
      type: Number,
      default: 0,
    },
    inHelpCenter: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isOpen: false,
      conversationLoading: false,
      demoContent: [],
      content: '',
      fileList: [],
      compFileList: [],
      ticketLists: [],
      submitLoading: false,
      currentRecord: {
        id: '',
      },
      loadingContent: false,
      successUploadList: [],
      successCompUploadList: [],
      sendLoading: false,
      quoteMessage: null,
      socket: null,
      total: 0,
      timer: null,
      hasAddId: [],
      sendingId: 0,
      errid: 0,
      editor: null,
      editorComplaint: null,
      expandImgUrl: '',
      showImgDialog: false,
      clientId: null,
      chatBoxHeight: 78,
      showYesOrNo: false,
      currentActive: '',
      viewHeight: window.visualViewport.height,
    };
  },
  created() {
    this.getTicketId();
  },
  mounted() {
    this.init();
    this.updateViewport();
    window.addEventListener("resize", this.updateViewport);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateViewport);
  },
  watch: {
    ticketAdd() {
      if (!this.isOpen) {
        return;
      }
      if (!this.currentRecord.id) {
        this.currentRecord.id = this.ticketId;
        this.$emit('resetUnreadCount');
        this.getHistoryExtra(true);
      } else {
        this.$emit('resetUnreadCount');
        this.getHistoryExtra(true);
      }
    },
    ticketId() {
      if (this.currentRecord.id == '') {
        this.currentRecord.id = this.ticketId;
        this.getHistoryByPage(false);
      }
    },
    inHelpCenter() {
      if (this.inHelpCenter) {
        this.isOpen = false;
      }
    }
  },
  methods: {
    // 将内容进行特殊字符转移
    escapeHTML(text) {
      let content = DOMPurify.sanitize(text);
      return content;
    },
    updateViewport() {
      this.viewHeight = window.visualViewport.height;
    },
    /**
     * 调用接口将isShow置为false
     */
    setIsShowFalse() {
      markAsSent(this.baseUrl, this.token, {ticketId: this.currentRecord.id}).then(res => {
        console.log(res)
      })
    },
    /**
     * 切换选项Now or Maybe later
     * @param {String} label
    */
    async changeActive(label) {
      if (this.sendLoading) {
        return;
      }
      this.currentActive = label;
      this.showYesOrNo = false;
      this.setIsShowFalse();
      this.sendLoading = true;
      let content = `<p>${this.translate(label)}</p>`;
      let params;
      params = {
        attachments: [],
        content: `<p>${this.translate(label)}</p>`,
        ticketId: this.currentRecord.id,
        quoteId: null,
        clientId: this.parseJwt(this.token)["custom:user_id"],
        contentIsHtml: true,
      };
      this.addMsg(false, false, false, content);
      let sendingId = this.sendingId;
      sendMessage(this.baseUrl, this.token, params)
        .then((res) => {
          this.sendLoading = false;
          if (res.code === 200) {
            this.changeMsgStatus(sendingId, res.data);
          } else {
            //正常发
            let created = new Date().getTime();
            let errorMsg = {
              attachments: [],
              content: `<p>${this.translate(label)}</p>`,
              quote: null,
              self: true,
              created: created,
              contentIsHtml: true,
              sender: {
                avatar: this.senderAvator,
                name: "Me",
              },
              isError: true,
              errid: this.errid++,
            };
            if (this.demoContent[0].sendingMsg) {
              this.demoContent.splice(0, 1, errorMsg);
            } else {
              this.demoContent.unshift(errorMsg);
            }
            this.scrollToNew();
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.sendLoading = false;
          let created = new Date().getTime();
          let errorMsg = {
            attachments: [],
            content: `<p>${this.translate(label)}</p>`,
            quote: null,
            self: true,
            contentIsHtml: true,
            created: created,
            sender: {
              avatar: this.senderAvator,
              name: "Me",
            },
            isError: true,
            errid: this.errid++,
          };
          if (this.demoContent[0].sendingMsg) {
            this.demoContent.splice(0, 1, errorMsg);
          } else {
            this.demoContent.unshift(errorMsg);
          }
          this.scrollToNew();
        });
    },
    /**
     * 打开、关闭聊天框
     */
    openChatBox() {
      if (this.inHelpCenter) {
        return;
      }
      this.updateViewport();
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        if (!this.currentRecord.id) {
          this.currentRecord.id = this.ticketId;
          this.getHistoryExtra(true);
        } else {
          this.getHistoryExtra(true);
        }
        if (window.localStorage.getItem('_selfChatContent') && !this.content) {
          this.content = window.localStorage.getItem('_selfChatContent');
          this.editor.txt.html(this.content);
        }
        this.$emit('resetUnreadCount');
      }
    },
    /**
     * 跳转帮助中心
     */
    toHelpCenter() {
      this.$emit('toHelpCenter');
    },
    /**
     * 滚动事件
     * @param {Event} e
     */
    handleScroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      if (Math.abs(scrollTop) + clientHeight + 20 >= scrollHeight) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(() => {
          this.getHistoryByPage(true, true);
        }, 500);
      }
    },
    /**
     * 翻译
     * @param {String} value
     */
    translate(value) {
      let language = this.translateLists;
      if (language) {
        for (let i in language) {
          if (
            language[i].key == value &&
            language[i].value !== null &&
            language[i].value !== ""
          ) {
            return language[i].value;
          }
        }
        return value;
      } else {
        return value;
      }
    },
    // 初始化富文本编辑器
    init() {
      this.editor = new E('#chat-box-editor');
      this.editor.config.placeholder = this.translate("Write a message");
      this.editor.config.onchange = (html) => {
        this.content = html;
        let inputHeight = document.querySelector('.cbp-content .cbp-content-opt');
        this.chatBoxHeight = inputHeight.clientHeight;
        window.localStorage.setItem('_selfChatContent', this.content);
      };
      setInterval(() => {
        let inputHeight = document.querySelector('.cbp-content .cbp-content-opt');
        this.chatBoxHeight = inputHeight.clientHeight;
      }, 1000);
      this.editor.config.customUploadImg = async (files, insertImgFn) => {
        for (let file of files) {
          const param = new FormData();
          param.append('file', file);
          const res = await axios({
            url: this.profileUrl+'/upload',
            method: 'post',
            data: param,
            headers: {
              authorization: 'Bearer ' + this.token,
              'content-type': 'multipart/formdata',
            },
          });
          insertImgFn(this.profileUrl + '/upload/download/' + res.data.content.id);
        }
      };
      this.editor.config.uploadImgShowBase64 = true;
      this.editor.config.showLinkImg = false;
      this.editor.config.showFullScreen = false;
      this.editor.create();
    },
    // handleRequestWord
    handleRequestComp(file) {
      // this.compFileList.push(file.file);

      console.log(file)
      this.receiveImageFromFlutter(file.file);
    },
    beforeAvatarUpload(file) {
      let perfix = file.name.split(".");
      let isJPG = true;
      if (
        ![
          "pdf",
          "png",
          "jpg",
          "svg",
          "jpeg",
          "bmp",
          "xls",
          "xlsx",
          "doc",
          "docx",
        ].includes(perfix[perfix.length - 1])
      ) {
        isJPG = false;
        this.$message.error(this.translate("Upload file type error"));
      }
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!isLt2M) {
        this.$message.error(
          this.translate("The size of the uploaded file cannot exceed 50 MB")
        );
      }
      return isJPG && isLt2M;
    },
    // 时间格式化
    timeFormat(value, showTime = true, justShowMinites = false, splitMinites=false) {
      let timezone = new Date().getTimezoneOffset();
      timezone = -Math.round(timezone/60);
      let lang = navigator.language || navigator.userLanguage;
      if (lang.indexOf('zh') > -1 || lang.indexOf('ko') > -1) {
        if (justShowMinites) {
          return moment(value).utcOffset(timezone).format('YYYY/MM/DD HH:mm');
        } else if (splitMinites) {
          return moment(value).utcOffset(timezone).format('HH:mm');
        }
        return showTime ? moment(value).utcOffset(timezone).format('YYYY/MM/DD HH:mm:ss') : moment(value).utcOffset(timezone).format('YYYY/MM/DD');
      } else {
        if (justShowMinites) {
          return moment(value).utcOffset(timezone).format('DD/MM/YYYY HH:mm');
        } else if (splitMinites) {
          return moment(value).utcOffset(timezone).format('HH:mm');
        }
        return showTime ? moment(value).utcOffset(timezone).format('DD/MM/YYYY HH:mm:ss') : moment(value).utcOffset(timezone).format('DD/MM/YYYY');
      }
    },
    //格式化显示消息时间
    initTimeStamp(value, index) {
      let agos = index < this.demoContent.length - 1 ? this.demoContent[index + 1].created : 0;
      if (Math.abs(new Date(value).setHours(0, 0, 0, 0) - new Date(agos).setHours(0, 0, 0, 0)) < 3600000*24) {
        return "";
      }
      // 判断Value是否是今天
      let today = new Date().setHours(0, 0, 0, 0);
      let currentTime = new Date(value);
      if (value) {
        let time = this.timeFormat(value, true, true);
        let arr = time.split(" ").reverse();
        if (currentTime.setHours(0, 0, 0, 0) === today) {
          return this.translate('Today');
        }
        return arr[1];
      }
    },
    // 上传文件
    receiveImageFromFlutter(file) {
      console.log('fileSize', file);
      let fileName = file.name;
      const isLimitSize = file.size / 1024 / 1024 < 50;
      if (!isLimitSize) {
        this.$message.error(this.translate("Maximum file size is 50MB"));
        return;
      }
      let isImg = ['jpg','jpeg','png','gif','webp','bmp','apng','ico','avif','svg'].includes(fileName.split('.')[1]);
      let formData = new FormData();
      formData.append('file', file, fileName);
      this.showBottomOpt = false;
      this.sendLoading = true;
      uploads(this.profileUrl, this.token, formData).then(res => {
        if (res.code == 200) {
          let results = res.content[0];
          this.successUploadList = isImg ? [] : [{id: results.id, filename: results.filename, fileRecordId: results.id, fileSize: file.size}];
          let params;
          params = isImg ? {
            attachments: [],
            content: `<p><img src=\"${this.profileUrl}/upload/download/${results.id}\" style=\"max-width:100%;\" data-set="%noPaddingParent%" contenteditable=\"false\"/></p>`,
            ticketId: this.currentRecord.id,
            quoteId: null,
            clientId: this.parseJwt(this.token)["custom:user_id"],
            contentIsHtml: true,
          } : {
            attachments: [{id: results.id, filename: results.filename, fileRecordId: results.id}],
            content: '',
            ticketId: this.currentRecord.id,
            quoteId: null,
            clientId: this.parseJwt(this.token)["custom:user_id"],
            contentIsHtml: true,
          };
          this.content = `<p><img src=\"${this.profileUrl}/upload/download/${results.id}\" style=\"max-width:100%;\" data-set="%noPaddingParent%" contenteditable=\"false\"/></p>`;
          if (this.showYesOrNo) {
            this.setIsShowFalse();
          }
          this.showYesOrNo = false;
          this.addMsg(false, false, !isImg);
          let sendingId = this.sendingId;
          this.editor.txt.clear();
          sendMessage(this.baseUrl, this.token, params)
            .then((res) => {
              var element = document.querySelector('.cbp-content-chat');
              if (element && element.scrollTop) {  
                element.scrollTop = 0;  
              }
              this.sendLoading = false;
              if (res.code === 200) {
                this.content = "";
                this.editor.txt.clear();
                window.localStorage.setItem('_selfChatContent', '');
                this.quoteMessage = null;
                this.fileList = [];
                this.successUploadList = [];
                this.changeMsgStatus(sendingId, res.data);
              } else {
                let created = new Date().getTime();
                let errorMsg = {
                  attachments: this.successUploadList,
                  content: this.content,
                  quote: this.quoteMessage,
                  self: true,
                  contentIsHtml: true,
                  created: created,
                  sender: {
                    avatar: this.senderAvator,
                    name: "Me",
                  },
                  isError: true,
                  errid: this.errid++,
                };
                if (this.demoContent[0].sendingMsg) {
                  this.demoContent.splice(0, 1, errorMsg);
                } else {
                  this.demoContent.unshift(errorMsg);
                }
                this.scrollToNew();
              }
            })
            .catch(() => {
              this.sendLoading = false;
              if (!resend) {
                let created = new Date().getTime();
                let errorMsg = {
                  attachments: this.successUploadList,
                  content: this.content,
                  quote: this.quoteMessage,
                  self: true,
                  contentIsHtml: true,
                  created: created,
                  sender: {
                    avatar: this.senderAvator,
                    name: "Me",
                  },
                  isError: true,
                  errid: this.errid++,
                };
                if (this.demoContent[0].sendingMsg) {
                  this.demoContent.splice(0, 1, errorMsg);
                } else {
                  this.demoContent.unshift(errorMsg);
                }
              } else {
                let created = new Date().getTime();
                let errorMsg = {
                  attachments: errEl.attachments,
                  content: errEl.content,
                  quote: errEl.quote,
                  self: true,
                  contentIsHtml: true,
                  created: created,
                  sender: {
                    avatar: this.senderAvator,
                    name: "Me",
                  },
                  isError: true,
                  errid: this.errid++,
                };
                if (this.demoContent[0].sendingMsg) {
                  this.demoContent.splice(0, 1, errorMsg);
                } else {
                  this.demoContent.unshift(errorMsg);
                }
              }

              this.scrollToNew();
            });
        }
      }).catch(()=>{
        this.sendLoading = false;
      });
    },
    /**
     * 放大缩略图
     * @param {Event} event 
     */
    expandImg(event) {
      const target = event.target;
      if (target.tagName.toLowerCase() === 'img') {
        const imageUrl = target.getAttribute('src');
        this.expandImgUrl = imageUrl;
        this.showImgDialog = true;
      }
    },
    showNameImg(name) {
      return this.isHedgehood ? `https://ui-avatars.com/api/?background=4b087a&color=fff&name=${name}&rounded=true&format=svg` : `https://ui-avatars.com/api/?background=0A853B&color=fff&name=${name}&rounded=true&format=svg`
    },
    parseJwt(token){
      const parts = token.split('.'); // 分割JWT的三个部分
      const payload =this.decodeBase64Url(parts[1]);  // 解码JWT的payload部分
      return JSON.parse(payload);// 将解码后的payload转换为对象
    },
    decodeBase64Url(input) {
      let base64 = input.replace(/-/g, '+').replace(/_/g, '/');
      switch (base64.length % 4) {
        case 0:
          break;
        case 2:
          base64 += '==';
          break;
        case 3:
          base64 += '=';
          break;
        default:
          throw 'Invalid base64 string';
      }
      return decodeURIComponent(atob(base64));
    },
    getHistoryByPage(value, isLoadHis, isFirst) {
      let params = {
        ticketId: this.currentRecord.id,
        pageSize: 20,
        isClient: true,
        t: new Date().getTime()
      };
      if (isLoadHis) {
        params["messageId"] = this.demoContent[this.demoContent.length - 1].id;
      }
      if (!value) {
        this.conversationLoading = true;
      }
      hisByPage(this.baseUrl, this.token, params)
        .then((res) => {
          this.conversationLoading = false;
          if (res.code === 200) {
            if (!value && res.data.length > 0) {
              let isShow = false;
              res.data.forEach((item) => {
                if (item.isShow) {
                  isShow = true;
                }
              })
              this.showYesOrNo = isShow;
              if (isShow && isFirst) {
                this.openChatBox();
              }
            }
            this.total = res.totalElements;
            if (this.isFirstScroll) {
              setTimeout(() => {
                window.scrollTo(0, document.body.scrollHeight);
              }, 100);
              this.isFirstScroll = false;
            }
            if (this.total <= this.demoContent.length) return;
            this.demoContent.push(...res.data);
            if (!isLoadHis) {
              this.scrollToNew();
            }
            this.$emit('setUnreadNum', 0)
          } else {
            this.$message.error(this.translate(res.msg));
          }
        })
        .catch(() => {
          this.conversationLoading = false;
        });
    },
    getHistoryExtra(value) {
      if (this.currentRecord.id == 0 || this.currentRecord.id == '') return;
      let params = {
        ticketId: this.currentRecord.id,
        pageSize: 20,
        isClient: true,
        t: new Date().getTime()
      };
      if (!value) {
        this.conversationLoading = true;
      }
      hisByPage(this.baseUrl, this.token, params)
        .then((res) => {
          this.conversationLoading = false;
          if (res.code === 200) {
            let isShow = false;
            res.data.forEach((item) => {
              if (item.isShow) {
                isShow = true;
              }
            })
            this.showYesOrNo = isShow;
            this.total = res.totalElements;
            this.demoContent = res.data;
            this.scrollToNew();
          } else {
            this.$message.error(this.translate(res.msg));
          }
        })
        .catch(() => {
          this.conversationLoading = false;
        });
    },
    //获取ticketid
    getTicketId() {
      this.conversationLoading = true;
      let params = {
        id: this.parseJwt(this.token)["custom:user_id"],
      };
      checkTicket(this.baseUrl, this.token, params)
        .then((res) => {
          if (res.code == 200) {
            this.currentRecord.id = res.data;
            if (this.currentRecord.id) {
              this.getHistoryByPage(false, false, true);
            } else {
              this.conversationLoading = false;
            }
          } else {
            this.conversationLoading = false;
          }
        })
        .catch(() => {
          this.conversationLoading = false;
        });
    },
    //发送成功后把消息转换成正常状态
    changeMsgStatus(sendingId, data) {
      let id = data.id;
      if (this.hasAddId.includes(id)) {
        return;
      }
      this.hasAddId.push(id);
      for (let item of this.demoContent) {
        if (item.sendingId == sendingId) {
          item.sendingMsg = false;
          item["sender"] = {
            name: data.sender.name,
            avatar: this.senderAvator,
            id: this.parseJwt(this.token)["custom:user_id"],
          };
          item.id = id;
        }
      }
    },
    //发送新消息后把消息添加到list
    addMsg(resend, errEl, isFile, content) {
      this.sendingId++;
      let msg;
      if (!resend) {
        msg = {
          attachments: this.successUploadList,
          content: content ? content : isFile ? '' : this.content,
          quote: isFile ? null : this.quoteMessage,
          self: true,
          contentIsHtml: true,
          created: new Date().getTime(),
          sendingId: this.sendingId,
          sendingMsg: true,
          sender: {
            avatar: this.senderAvator,
            id: this.parseJwt(this.token)["custom:user_id"],
          },
        };
      } else {
        msg = {
          attachments: errEl.attachments,
          content: errEl.content,
          quote: errEl.quote,
          self: true,
          contentIsHtml: true,
          created: new Date().getTime(),
          sendingId: this.sendingId,
          sendingMsg: true,
          sender: {
            avatar: this.senderAvator,
            id: this.parseJwt(this.token)["custom:user_id"],
          },
        };
      }
      this.demoContent.unshift(msg);
    },
    // download
    download(file) {
      if (this.isApp) {
        let url = `${this.profileUrl}/upload/download/${file.fileRecordId}`;
        try {
          window.flutter_inappwebview.callHandler('postMessage', `download:${url}`);
        } catch (error) {
          
        }
        return;
      }
      downloadFile(this.profileUrl, this.token, file.fileRecordId).then(
        (res) => {
          let data = res.data;
          const contentDisposition = res.headers["content-disposition"];
          let fileName = "file";
          if (contentDisposition) {
            fileName = decodeURIComponent(
              contentDisposition.split("utf-8''")[1]
            );
          }
          if (!data) {
            this.$message.error(this.translate("Download failed"));
            return;
          } else {
            this.$message.success(this.translate("Download Successfully"));
          }
          if (typeof window.navigator.msSaveBlob !== "undefined") {
            window.navigator.msSaveBlob(new Blob([data]), fileName);
          } else {
            let url = window.URL.createObjectURL(new Blob([data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        }
      );
    },
    // 发送消息
    async sendMessage(resend, errEl) {
      console.log(resend, errEl)
      if (this.content.trim() === "") {
        return;
      }
      this.sendLoading = true;
      let params;
      if (this.showYesOrNo) {
        this.setIsShowFalse();
      }
      this.showYesOrNo = false;
      if (!resend) {
        //正常发
        if (this.fileList.length > 0) {
          await this.uploadFile();
        }
        params = {
          attachments: this.successUploadList,
          content: DOMPurify.sanitize(this.content),
          ticketId: this.currentRecord.id,
          quoteId: this.quoteMessage ? this.quoteMessage.id : null,
          clientId: this.parseJwt(this.token)["custom:user_id"],
          contentIsHtml: true,
        };
        this.addMsg();
      } else {
        //重发
        for (let index in this.demoContent) {
          let item = this.demoContent[index];
          if (item.isError && item.errid == errEl.errid) {
            this.demoContent.splice(index, 1);
          }
        }
        params = {
          attachments: errEl.attachments,
          content: DOMPurify.sanitize(errEl.content),
          ticketId: this.currentRecord.id,
          quoteId: errEl.quoteId,
          clientId: this.parseJwt(this.token)["custom:user_id"],
          contentIsHtml: true,
        };
        this.addMsg(true, errEl);
      }
      let sendingId = this.sendingId;
      this.editor.txt.clear();
      sendMessage(this.baseUrl, this.token, params)
        .then((res) => {
          this.sendLoading = false;
          if (res.code === 200) {
            this.content = "";
            this.editor.txt.clear();
            window.localStorage.setItem('_selfChatContent', '');
            this.quoteMessage = null;
            this.fileList = [];
            this.successUploadList = [];
            this.changeMsgStatus(sendingId, res.data);
          } else {
            if (!resend) {
              //正常发
              let created = new Date().getTime();
              let errorMsg = {
                attachments: this.successUploadList,
                content: this.content,
                quote: this.quoteMessage,
                self: true,
                created: created,
                contentIsHtml: true,
                sender: {
                  avatar: this.senderAvator,
                  name: "Me",
                },
                isError: true,
                errid: this.errid++,
              };
              if (this.demoContent[0].sendingMsg) {
                this.demoContent.splice(0, 1, errorMsg);
              } else {
                this.demoContent.unshift(errorMsg);
              }
            } else {
              //重发
              let created = new Date().getTime();
              let errorMsg = {
                attachments: errEl.attachments,
                content: errEl.content,
                quote: errEl.quoteMessage,
                self: true,
                created: created,
                contentIsHtml: true,
                sender: {
                  avatar: this.senderAvator,
                  name: "Me",
                },
                isError: true,
                errid: this.errid++,
              };
              if (this.demoContent[0].sendingMsg) {
                this.demoContent.splice(0, 1, errorMsg);
              } else {
                this.demoContent.unshift(errorMsg);
              }
            }
            this.scrollToNew();
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.sendLoading = false;
          if (!resend) {
            let created = new Date().getTime();
            let errorMsg = {
              attachments: this.successUploadList,
              content: this.content,
              quote: this.quoteMessage,
              self: true,
              contentIsHtml: true,
              created: created,
              sender: {
                avatar: this.senderAvator,
                name: "Me",
              },
              isError: true,
              errid: this.errid++,
            };
            if (this.demoContent[0].sendingMsg) {
              this.demoContent.splice(0, 1, errorMsg);
            } else {
              this.demoContent.unshift(errorMsg);
            }
          } else {
            let created = new Date().getTime();
            let errorMsg = {
              attachments: errEl.attachments,
              content: errEl.content,
              quote: errEl.quoteMessage,
              self: true,
              contentIsHtml: true,
              created: created,
              sender: {
                avatar: this.senderAvator,
                name: "Me",
              },
              isError: true,
              errid: this.errid++,
            };
            if (this.demoContent[0].sendingMsg) {
              this.demoContent.splice(0, 1, errorMsg);
            } else {
              this.demoContent.unshift(errorMsg);
            }
          }

          this.scrollToNew();
        });
    },
    //滚动到最新消息
    scrollToNew() {
      setTimeout(() => {
        if (document.querySelector(".cbp-content-chat")) {
          document.querySelector(
            ".cbp-content-chat"
          ).scrollTop = document.querySelector(
            ".cbp-content-chat"
          ).scrollHeight;
        }
      }, 10);
    },
  }
};
</script>
<style lang="scss">
.chat-box-mobile {
  .w-e-toolbar {
    display: none !important;
    z-index: 1 !important;
  }
  .w-e-text-container {
    border-top: 1px solid #c9d8db !important;
    border-radius: 8px;
    font-family: "Montserrat-Regular";
    z-index: 1 !important;
    height: auto !important;
    max-height: 146px;
    overflow: auto;
    flex-direction: column-reverse;
    scrollbar-color: #c1c5c9 #f5f5f5; /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
    scrollbar-width: thin; /* 火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细 */
    -ms-overflow-style: none; /* 隐藏滚动条（在IE和Edge两个浏览器中很难更改样式，固采取隐藏方式） */
    /* 以下是chrome浏览器自定义滚动条样式方式 */
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 93px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 3px;
      -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
      background: #c1c5c9;
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
      border-radius: 3px;
      background-color: #f5f5f5;
    }
    img{
      vertical-align: top;
      margin-right: 8px;
    }
    .w-e-text {
      padding: 12px 76px 12px 16px;
    }
    .placeholder{
      top: 14px;
      left: 16px;
    }
    p {
      font-size: 16px;
      line-height: 24px;
      margin: 0px;
    }
  }
  .replay-content{
    img{
      width: 110px;
      cursor: pointer;
      vertical-align: top;
      margin-right: 8px;
    }
  }
}
p{
  overflow-wrap: anywhere;
}
.self-tooltip{
  z-index: 1000001 !important;
}
.special-btn {
  width: 24px;
  height: 24px;
  padding: 0;
}
.no-padding-bd{
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
  min-width: auto !important;
  .mgr-16{
    margin-right: 0 !important;
  }
  .text-right{
    display: none !important;
  }
  img{
    margin-right: 0 !important;
    border-radius: 8px;
  }
}
</style>
<style scoped lang="scss">
@import url("./common.scss");
@-webkit-keyframes circle1 {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
.common-check-container{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  .common-check{
    padding: 12px 28px;
    border-radius: 50px;
    border: 1px solid #E9E9E9;
  }
}
.msg-loading-wrap {
  margin-top: 13px;
  text-align: right;
  .loading-icon {
    animation: circle1 2s infinite linear;
    animation-delay: 0s;
  }
}
*{
  font-family: "Montserrat-Regular";
}
.chat-box-mobile {
  .cbp-icon {
    position: fixed;
    z-index: 1000001;
    right: 16px;
    background: #FFFFFF;
    bottom: 24px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    box-shadow: -8px 0px 20px 0px rgba(0, 0, 0, 0.08),
      8px 8px 20px 0px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .unread-count{
      position: fixed;
      border: 1px solid #ffffff;
      z-index: 1000002;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #fff;
      transform: translateX(20px) translateY(-20px);
    }
  }
  .icon-img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .cbp-content{
    overflow: hidden;
    position: fixed;
    z-index: 1000002;
    right: 0;
    bottom: 0;
    width: 100vw;
    box-shadow: -8px 0px 20px 0px rgba(0, 0, 0, 0.08), 8px 8px 20px 0px rgba(0, 0, 0, 0.08);
    border-radius: 0px;
    .cbp-content-head{
      background: #FFFFFF;
      height: 64px;
      padding: 0 16px;
      .head-img-zero{
        height: 24px;
      }
      .head-img-hh{
        height: 30px;
      }
    }
    .cbp-content-chat{
      box-sizing: border-box;
      list-style: none;
      padding: 12px 0;
      overflow: auto;
      display: flex;
      flex-direction: column-reverse;
      scrollbar-color: #c1c5c9 #f5f5f5; /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
      scrollbar-width: thin; /* 火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细 */
      -ms-overflow-style: none; /* 隐藏滚动条（在IE和Edge两个浏览器中很难更改样式，固采取隐藏方式） */
      /* 以下是chrome浏览器自定义滚动条样式方式 */
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 93px;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 3px;
        -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
        background: #c1c5c9;
      }
      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
        border-radius: 3px;
        background-color: #f5f5f5;
      }
      .relative{
        position: relative;
      }
      .common-li{
        display: flex;
        justify-content: flex-end;
        padding: 16px 16px 8px 32px;
        .common-li-tool {
          display: flex;
          flex-direction: column;
          .retry {
            display: flex;
            align-items: center;
            margin-top: 10px;
            span {
              color: #0a853b;
              font-size: 16px;
              font-weight: 600;
              line-height: 24px;
            }
            .error-icon {
              margin-left: 8px;
              width: 20px;
              height: 20px;
              color: #a70c0c;
            }
          }
          .msg-loading-wrap {
            position: absolute;
            left: -24px;
            margin-top: 13px;
            text-align: right;
            .loading-icon {
              animation: circle1 2s infinite linear;
              animation-delay: 0s;
            }
          }
        }
      }
      .other-li {
        flex-direction: column;
        padding: 16px 32px 8px 16px;
      }
      ._timeColor{
        margin-top: 8px;
      }
      .replay-content {
        border: 1px solid #eeeeee;
        border-radius: 8px;
        padding: 8px 16px;
        font-size: 14px;
        line-height: 24px;
        min-width: 100px;
        box-sizing: border-box;
        .extra {
          font-size: 12px;
          line-height: 16px;
          color: #565656;
          text-align: right;
        }
      }
      .refresh {
        background: #ffffff;
      }
      .replay-role {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        .role-icon {
          width: 40px;
          height: 40px;
          color: #c1c5c9;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .name {
          font-size: 14px;
          line-height: 24px;
          font-family: 'Montserrat-SemiBold';
          width: 80px;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-left: 8px;
        }
      }
    }
    .no-chat-container{
      list-style: none;
      box-sizing: border-box;
      padding: 12px 0;
      height: calc(100vh - 522px);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .no-chat-img{
        height: 150px;
        width: auto;
      }
    }
    .cbp-content-opt{
      padding: 12px 16px 40px;
      position: relative;
      .cbp-content-btn{
        position: absolute;
        right: 32px;
        bottom: 52px;
        z-index: 1000001;
      }
      .h-24{
        height: 24px;
      }
    }
  }
  .expand-img-container{
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000002;
    transition: all 0.5s;
    width: 100vw;
    height: 100vh;
    bottom: 0px;
    right: 0px;
    background-color: rgba(0, 0, 0, 0.8);
    .eic-header{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 70px;
      transition: all 0.5s;
      z-index: 1000003;
      svg{
        margin-right: 24px;
        cursor: pointer;
      }
    }
    .eic-img{
      height: auto;
      width: auto;
      max-height: 100%;
      max-width: 100%;
      user-select: none;
      margin: auto;
      z-index: 1000002;
      vertical-align: middle;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/packages/chatBox/components/mobile.vue